import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import React from 'react';
import TextField from 'material-ui/TextField';
import Joi from 'joi';
import validation from 'react-validation-mixin';
import strategy from 'joi-validation-strategy';

class EmployeeEditDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      err_msg: '',
      employee_data: {},
      open: false
    }

    this.validatorTypes = {
      last_name: Joi.string()
        .required()
        .min(2, 'utf8')
        .max(50, 'utf8'),
      first_name: Joi.string()
        .required()
        .min(2, 'utf8')
        .max(50, 'utf8')
    }

    this.open_edit = this.open_edit.bind(this)
    this.cancel_edit = this.cancel_edit.bind(this)
    this.getValidatorData = this.getValidatorData.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  getValidatorData() {
    return this.state.employee_data.user
  }

  open_edit(data) {
    this.setState({
      employee_data: data,
      err_msg: '',
      open: true
    })
  }

  cancel_edit() {
    this.setState({
      open: false
    })
  }

  handleChange(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState(Object.assign(
      this.state.employee_data.user, {
        [name]: value
      }
    ));
  }

  handleBlur(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState(Object.assign(
        this.state.employee_data.user, {
          [name]: value
        }
      ),
      this.props.handleValidation(name)
    )
  }

  handleSubmit(e) {
    this.props.validate((_err) => {
      if (_err) return
      this.props.submit_edit(
        this.state.employee_data,
        (err) => {
          if (err) {
            this.setState({err_msg: err.message})
          }
          else this.setState({open: false}, () => {
            this.props.history.push('/employees/all')
          })
        }
      )
    })
  }

  renderHelperText(msg) {
    var err_msg = msg
    if (Array.isArray(msg) && msg.length > 0) {
      err_msg = msg[0]
    }
    return (
      <span styleName="">{err_msg}</span>
    )
  }

  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        onClick={this.cancel_edit}
      />,
      <FlatButton
        label="Change"
        keyboardFocused={true}
        onClick={this.handleSubmit}
        disabled={!this.props.isValid()}
      />,
    ]
    var employee_email = ''
    if (!this.state.employee_data.user) {
      return null
    }
    var user_data = this.state.employee_data.user
    employee_email = user_data.username
    return (
      <Dialog
        open={this.state.open}
        title="Edit Employee Information"
        modal={true}
        actions={actions}
      >
        <div>{this.state.err_msg}</div>
        <TextField
          floatingLabelText="Employee Email"
          floatingLabelFixed={true}
          name="email"
          value={employee_email}
          disabled={true}
        />
        <br />
        <TextField
          floatingLabelText="Employee Firstname"
          floatingLabelFixed={true}
          name="first_name"
          value={user_data.first_name || ''}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          errorText={this.renderHelperText(this.props.getValidationMessages('first_name'))} />
        <br />
        <TextField
          floatingLabelText="Employee Lastname"
          floatingLabelFixed={true}
          name="last_name"
          value={user_data.last_name || ''}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          errorText={this.renderHelperText(this.props.getValidationMessages('last_name'))} />
        <br />
      </Dialog>
    )
  }
}

EmployeeEditDialog.defaultProps = {
  submit_edit: null,
  history: null
}

export default validation(strategy)(EmployeeEditDialog)



// WEBPACK FOOTER //
// ./src/views/admin/employee_edit.react.js